import React, { useState } from 'react';
import Popover from '@mui/material/Popover';
import ListItem from '@mui/material/ListItem';
import Button from '@mui/material/Button';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import OutlinedInput from '@mui/material/OutlinedInput';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { ExpressionPath, Literal } from '../types';
import AttrSelectorProvider, { AttrPath } from '../../components/AttrSelectorProvider';
import { normalProps, selectedProps } from './OpSelector';
import { ListConf } from 'src/domains/query/types';
import { getFieldLabel } from 'src/config'

const PathOrLiteralSelector: React.FC<{
    anchorEl: Element | null,
    listConf: ListConf,
    onClose: () => void,
    pathValue: string | ExpressionPath | Literal,
    handlePathSelected: (attrPath: AttrPath) => void,
    handleLiteralSet: (value: string) => void,
    defaultLiteral?: boolean,
    hidden: boolean
}> = ({
    anchorEl,
    listConf,
    onClose,
    pathValue,
    handlePathSelected,
    handleLiteralSet,
    defaultLiteral = false,
    hidden
}) => {
        const [literalValue, setLiteralValue] = useState<string>('');
        const [mode, setMode] = useState<number>(defaultLiteral ? 1 : 0);

        const handleChangeMode = (event: React.SyntheticEvent, newValue: number) => {
            setMode(newValue);
        };

        return <Popover
            id={'columns-config-popover'}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >

            <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
                <Tabs value={mode} onChange={handleChangeMode} centered>
                    <Tab label="Property" />
                    <Tab label="Value" />
                </Tabs>
            </Box>

            {
                mode == 1 && <Box textAlign={'center'} mt={theme => theme.spacing(0.5)}><OutlinedInput
                    inputProps={{ style: { textAlign: 'center', padding: 4 } }}
                    id={'literal'}
                    value={literalValue}
                    onChange={(e) => setLiteralValue(e.target.value)}
                    autoComplete='off'
                /></Box>
            }

            {
                mode == 0 && <AttrSelectorProvider
                    hidden={hidden}
                    listConf={listConf}
                >
                    {({
                        path,
                        id,
                    }) => {
                        return <ListItem
                            disablePadding
                            key={path.path}
                            sx={pathValue === path.path ? selectedProps : normalProps}
                            onClick={() => {
                                handlePathSelected(path);
                                onClose();
                            }}
                        >
                            <ListItemButton>
                                <ListItemText id={id} primary={`${getFieldLabel(path.field)}`} />
                            </ListItemButton>
                        </ListItem>
                    }}
                </AttrSelectorProvider>
            }

            <Box textAlign='center'>
                <Button
                    onClick={() => {
                        if (mode == 1) {
                            handleLiteralSet(literalValue);
                        }
                        onClose();
                    }}
                    variant='contained'
                    sx={{ m: 1 }}
                    size='small'
                >
                    {'Ok'}
                </Button>
            </Box>
        </Popover>
    }

export default PathOrLiteralSelector;